import * as stylex from "@stylexjs/stylex";

import { Icon } from "@animus/primaris";

import { styles } from "./styles.stylex";

interface StatCardProps {
  title: string;
  value: number;
  color: "blue" | "red" | "green";
  icon?: string;
}

function StatCard({ title, value, color, icon }: StatCardProps) {
  return (
    <div {...stylex.props(styles.card)}>
      <div {...stylex.props(styles.header)}>
        {icon && <Icon size="sm" svg={icon} xstyle={styles[color]} />}
        <p {...stylex.props(styles.title)}>{title}</p>
      </div>
      <p {...stylex.props(styles.value, styles[color])}>{value}</p>
    </div>
  );
}

export { StatCard, type StatCardProps };
